import script from "./OnlineTest.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineTest.vue?vue&type=script&setup=true&lang=js"

import "./OnlineTest.vue?vue&type=style&index=0&id=079553b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079553b4"]])

export default __exports__